import axiosInstanceNew from "../lib/axiosinstanceNew";

const ReportModel = class {
  constructor() {
    this.staticData = [
      {
        monthName: "January 2024",
        classResult: {
          total_sales: 150000,
          net_sales: 135000,
          tutor_salary: 45000,
        },
      },
      {
        monthName: "February 2024",
        classResult: {
          total_sales: 165000,
          net_sales: 148500,
          tutor_salary: 49500,
        },
      },
      {
        monthName: "March 2024",
        classResult: {
          total_sales: 180000,
          net_sales: 162000,
          tutor_salary: 54000,
        },
      },
      {
        monthName: "April 2024",
        classResult: {
          total_sales: 195000,
          net_sales: 175500,
          tutor_salary: 58500,
        },
      },
      {
        monthName: "May 2024",
        classResult: {
          total_sales: 210000,
          net_sales: 189000,
          tutor_salary: 63000,
        },
      },
      {
        monthName: "June 2024",
        classResult: {
          total_sales: 225000,
          net_sales: 202500,
          tutor_salary: 67500,
        },
      },
      {
        monthName: "July 2024",
        classResult: {
          total_sales: 240000,
          net_sales: 216000,
          tutor_salary: 72000,
        },
      },
      {
        monthName: "August 2024",
        classResult: {
          total_sales: 255000,
          net_sales: 229500,
          tutor_salary: 76500,
        },
      },
      {
        monthName: "September 2024",
        classResult: {
          total_sales: 270000,
          net_sales: 243000,
          tutor_salary: 81000,
        },
      },
      {
        monthName: "October 2024",
        classResult: {
          total_sales: 285000,
          net_sales: 256500,
          tutor_salary: 85500,
        },
      },
      {
        monthName: "November 2024",
        classResult: {
          total_sales: 300000,
          net_sales: 270000,
          tutor_salary: 90000,
        },
      },
      {
        monthName: "December 2024",
        classResult: {
          total_sales: 315000,
          net_sales: 283500,
          tutor_salary: 94500,
        },
      },
    ];
  }

  async list() {
    return (await axiosInstanceNew.get(`report/income`)).data;
  }
  async listbydate(id, iid) {
    return (await axiosInstanceNew.get(`report/income?from=${id}&to=${iid}`))
      .data;
  }

  async Revenuelist() {
    return (await axiosInstanceNew.get(`report/revenue`)).data;
  }
  async overcomelistbydate(id, iid) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: this.staticData,
      };
    } catch (error) {
      console.error("Error fetching income over time data:", error);
      throw error;
    }
  }
};

export default new ReportModel();
